import { styled, Switch, SwitchProps } from "@mui/material";
import {
	NeutralColor,
	PrimaryColor,
	SecondaryColor,
} from "node-library/dist/colors";

const LargeSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 110,
	height: 38,
	borderRadius: 25,
	border: `1px solid ${NeutralColor.NEUTRAL_GREY_900}`,
	padding: 0,
	"& .MuiSwitch-switchBase": {
		padding: 3,
		margin: 0,
		transitionDuration: "300ms",
		width: "50%",
		height: "100%",
		color: NeutralColor.NEUTRAL_GREY_900,
		"&.Mui-checked": {
			transform: "translateX(55px)",
			color: PrimaryColor.PRIMARY_800,
			"& + .MuiSwitch-track": {
				backgroundColor: "transparent",
				opacity: 1,
				border: 0,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: 0.5,
			},
		},

		"&.Mui-disabled + .MuiSwitch-track": {
			opacity: 0.7,
		},
	},
	"& .MuiSwitch-thumb": {
		boxSizing: "border-box",
		width: "100%",
		height: "100%",
		borderRadius: 25,
	},
	"& .MuiSwitch-track": {
		backgroundColor: "transparent",
		opacity: 1,
	},
}));

const CustomSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 44,
	height: 22,
	borderRadius: 25,
	padding: 0,
	"& .MuiSwitch-switchBase": {
		padding: 3,
		margin: 0,
		transitionDuration: "300ms",
		width: "40%",
		height: "100%",
		color: PrimaryColor.PRIMARY_800,
		"&.Mui-checked": {
			transform: "translateX(26px)",
			color: "white",
			"& + .MuiSwitch-track": {
				backgroundColor: PrimaryColor.PRIMARY_800,
				opacity: 1,
				border: 0,
			},
			"&:hover + .MuiSwitch-track": {
				backgroundColor: PrimaryColor.PRIMARY_200,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: 0.5,
			},
		},
		"&.Mui-disabled + .MuiSwitch-track": {
			opacity: 0.7,
		},
	},
	"& .MuiSwitch-thumb": {
		boxSizing: "border-box",
		width: "10px",
		height: "10px",
		borderRadius: "50%",
		padding: "5px",
	},
	"& .MuiSwitch-track": {
		backgroundColor: PrimaryColor.PRIMARY_100,
		opacity: 1,
		transition: "background-color 300ms",
	},
	"&:hover .MuiSwitch-track": {
		backgroundColor: PrimaryColor.PRIMARY_50,
	},
}));

export { LargeSwitch, CustomSwitch };
